import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
import echarts from 'echarts';
import { debounce } from '@/utils';
export default {
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 100
    },
    chartData: {
      // 图表数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    legendName: {
      // 图例名称
      type: Array,
      default: function _default() {
        return [];
      }
    },
    xAxisData: {
      // x轴数据
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.chart.clear();
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions(chartData, legendName, xAxisData) {
      var that = this;
      var series = [];
      legendName.forEach(function (item, index) {
        series.push({
          name: item,
          type: 'line',
          symbol: 'none',
          smooth: true,
          data: chartData[index],
          areaStyle: {
            opacity: 0.1
          }
        });
      });
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          // 按x轴显示
          show: true,
          axisPointer: {
            lineStyle: {
              color: 'none' //   不显示线条

            }
          },
          textStyle: {
            align: 'left',
            fontSize: 12,
            color: '#fff'
          },
          extraCssText: 'box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2)' //   添加阴影

        },
        color: ['#38C171', '#EEB700', '#C15038', '#EEB700', '#5CE5FE', '#63BCDF', '#027BFA', '#C89131', '#FF7723', '#25f295', '#ff7723', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378ea'],
        grid: {
          left: '7%',
          right: '5%',
          top: '14%',
          bottom: '20%'
        },
        legend: {
          type: 'scroll',
          //图例滚动模式
          orient: 'horizontal',
          // vertical 滚动方向
          pageIconColor: "white",
          //激活的分页按钮颜色
          pageIconInactiveColor: "#2f4554",
          //没激活的分页按钮颜色
          pageTextStyle: {
            color: "white" //分页文字颜色

          },
          show: true,
          icon: 'circle',
          itemWidth: 9,
          temHeight: 9,
          left: 5,
          right: 5,
          top: -5,
          textStyle: {
            fontSize: 12,
            color: '#fff'
          },
          data: legendName
        },
        xAxis: [{
          type: 'category',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'blue',
              opacity: 0.05
            }
          },
          axisLabel: {
            show: true,
            color: '#6F93D5',
            textStyle: {
              color: '#fff'
            },
            fontSize: 10
          },
          boundaryGap: false,
          data: xAxisData
        }],
        yAxis: [{
          minInterval: 1,
          nameTextStyle: {
            color: '#7195D7',
            fontSize: 10
          },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              // type: 'dashed',
              color: 'rgba(255, 255, 255, 0.18)'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['transparent']
            }
          },
          axisLabel: {
            show: true,
            color: '#6F93D5',
            textStyle: {
              color: '#fff'
            },
            fontSize: 10,
            interval: 0
          }
        }],
        series: series
      });
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.myEchart, 'macarons');
      this.setOptions(this.chartData, this.legendName, this.xAxisData);
    }
  }
};